import React from 'react'
import { GalleryLoader } from '../../../utils/import.gallery';

import changeBtn from './../../../UI/general/nextBtn.svg'

interface Props {
    isGalleryOpened: boolean,
    currentImage: number,
    selectedBike: any,
    handleOpenImage: any
}

interface State {
    selectedImage: any
}

class FullGalleryMobile extends React.Component<Props,State>{
    constructor(props: Props){
        super(props);
        this.state = {
            selectedImage: ""
        }
    }

    componentDidUpdate(prevProps: any){
        if(prevProps.currentImage !== this.props.currentImage && this.props.currentImage !== -1 && GalleryLoader[this.props.selectedBike.Nombre] !== undefined){
            this.setState({
                selectedImage: GalleryLoader[this.props.selectedBike.Nombre]()[this.props.currentImage].default
            }, () => {console.log(this.state.selectedImage)})
        } 
    }
    
    handlePrevBtn = () => {
        this.props.handleOpenImage(true, this.props.currentImage - 1 > -1 ? this.props.currentImage - 1 : GalleryLoader[this.props.selectedBike.Nombre]().length - 1)
    }

    handleNextBtn = () => {
        this.props.handleOpenImage(true, this.props.currentImage + 1 < GalleryLoader[this.props.selectedBike.Nombre]().length ? this.props.currentImage + 1 : 0)
    }

    render(): React.ReactNode {
        return(
            <div className={this.props.isGalleryOpened ? 'full-gallery-mobile fade-in':'full-gallery-mobile fade-out'}>
                <div className='cerrar-btn-mobile' onClick={() => {this.props.handleOpenImage(false, -1)}}>
                    CERRAR
                </div>
                <div className='gallery-container-mobile'>
                    <img className='' src={this.state.selectedImage}> 
                </img>
                </div>
                <div className='prev-btn-mobile' onClick={() => {this.handlePrevBtn()}}>
                    <img src={changeBtn}></img>
                    <div className='next-btn-text-mobile'>
                        ANTERIOR
                    </div>
                </div>
                <div className='next-btn-mobile' onClick={() => {this.handleNextBtn()}}>
                    <div className='next-btn-text-mobile'>
                        SIGUIENTE
                    </div>
                    <img src={changeBtn}></img>
                </div>
            </div>
        )
    }
}

export default FullGalleryMobile